import { logger } from 'cadenza/utils/logging';
import { errorAlert } from 'cadenza/alert';
import i18n from 'cadenza/conditions/date-picker/messages.properties';

export function showDatePickerModal (datePicker, dateConfiguration, datePreset, styleClass) {
  import(/* webpackChunkName: "date-picker-modal" */ './date-picker-modal/date-picker-modal').then(({ DatePickerModal }) => {
    const dialog = new DatePickerModal(
      datePicker,
      dateConfiguration,
      datePreset,
      styleClass
    );
    dialog.addEventListener('close', () => {
      dialog.remove();
      if (dialog.returnValue) {
        datePicker.values = dialog.returnValue;
        datePicker.dispatchChange();
      } else {
        datePicker.tryToSubmitTextValueIfNeeded();
      }
    });
    document.body.appendChild(dialog);
    dialog.showModal();
  }).catch((error) => {
    logger.error(error);
    errorAlert(i18n('error.dialog.title'), i18n('error.dialog.message'));
  });
}
